// components/Login.jsx
import React, { useEffect, useState } from 'react';
import SquareCard from '../specific/loginCard'; // Asegúrate de que la ruta sea correcta
import Popup from '../specific/popUpResetPassword';
import Footer from '../common/footer';
import { PostResetPasswordService } from '../../Services/resetPasswordService';
import Header from '../common/header';
import { useTranslation } from "react-i18next";

function ResetPassword() {
  const [t] = useTranslation("login")
  const [email, setEmail] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [textBody, setTextBody] = useState('');
  const [redirect, setRedirect] = useState(false);

  const handleResetPassword = async (e) => {
    setLoading(true)
    e.preventDefault();
    const response = await (PostResetPasswordService(email));
    setTextBody(response.message);
    response.success ? setRedirect(true) : setRedirect(false);
    setLoading(false)
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    localStorage.removeItem("authInfo");
  }, [])

  return (
    <div>
      <Header
        translucent
        showUpdate={false}
      />
      <SquareCard
        buttonText={`${t("resetPassCard.login")}`}
        onSubmit={handleResetPassword}
        setEmail={setEmail}
        type="reset-password"
        loading={loading}
      />
      <Popup show={showPopup} handleClose={handleClosePopup} title={`${t("popupSuccessResetPass.title")}`} textBody={textBody} redirect={redirect} />
      <Footer absolutePosition />
    </div>
  );
}

export default ResetPassword;